import RAAThermique from './../components/pages/RAAThermique'
import store from './../stores/front'

Vue.prototype.$api = window.$api

new Vue({
  store,
  el: '.vue-raa-thermique',
  render: h => h(RAAThermique)
});
